export default __webpack_public_path__ + "static/media/PROCESSMETHOD_MOLDING_INSERT_INJECTION.9d3c63ce.png";